export class Nav{

  constructor(app) {
    
    this.gNavList= $('.gnav__item');
    this.megaMenuList= $('.megamenu');
    this.gNavList.hover(
      this.rollOver.bind(this),
      this.rollOut.bind(this)
    );
    
    this.gNavMember = $('#gnavMember');
    this.gNavMember.hover(()=>{
        $(this).addClass(CLASS_IS_ACTIVE);
      },()=>{
        $(this).removeClass(CLASS_IS_ACTIVE);
      }
    );
    
    this.megaMenuTitle = $('.megamenu__ttl');
    this.megaMenuTitle.click(this.toggleMegamenuSP.bind(this));
    
    this.hamburger = $('.hamburger');
    this.hamburger.click(this.toggleMenuSP.bind(this));
    
    this.body = $('body');
    this.gnav = $('.gnav');
    
    this.scrollY = 0;
  }

  toggleMenuSP(e){
    this.body.toggleClass(CLASS_IS_FIX);
    this.hamburger.toggleClass(CLASS_IS_ACTIVE);
    this.gnav.toggleClass(CLASS_IS_ACTIVE);
    if(this.body.hasClass(CLASS_IS_FIX)){
      this.openMenu(e);      
    }else{
      this.closeMenu(e);
    }
  }

  openMenu(e){
    this.body.css('top',0);
    this.scrollY = window.scrollY || window.pageYOffset;
  }
  closeMenu(e){
    this.body.css('top',-this.scrollY+'px');
  }

  toggleMegamenuSP(e){

    let target = $(e.currentTarget);
    target.toggleClass(CLASS_IS_ACTIVE);
    target.next().toggleClass(CLASS_IS_ACTIVE);
    
  }
  
  rollOver(e){
    let target = $(e.currentTarget);
    target.addClass(CLASS_IS_ACTIVE);
    target.find('.megamenu').addClass(CLASS_IS_ACTIVE);
  }
  rollOut(e){
    let target = $(e.currentTarget);
    target.removeClass(CLASS_IS_ACTIVE);
    target.find('.megamenu').removeClass(CLASS_IS_ACTIVE);
  }

}